import { Component, ChangeDetectionStrategy, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonComponent, IconComponent } from '@pansa/ui';
import { MessagePanelService } from '../../services/message-panel.service';
import { CreateMessageDTO, CreateMessageForm, Recipient } from '../../models/message.model';
import { RecipientSelectComponent } from '../recipient-select/recipient-select.component';
import { QuillModule } from 'ngx-quill';
import { MessageService } from '../../services/message.service';

@Component({
  selector: 'rqa-message-create',
  templateUrl: './message-create.component.html',
  styleUrl: './message-create.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    IconComponent,
    RecipientSelectComponent,
    QuillModule,
  ]
})
export class MessageCreateComponent implements OnInit {
  private fb = inject(FormBuilder);
  readonly messagePanelService = inject(MessagePanelService)
  readonly messageService = inject(MessageService)
  messageForm!: FormGroup<CreateMessageForm>

  ngOnInit(): void {
    this.buildForm();
  }

  onClose(): void {
    this.messagePanelService.close();
  }

  onSend(): void {
    const formValue = this.messageForm.getRawValue();
    const recipients = this.messageForm.controls.recipient.value;
    const usernames = recipients.flatMap(recipient =>
      'webRqaUsers' in recipient
        ? recipient.webRqaUsers.map(user => user.username)
        : [recipient.username]
    );

    const uniqueUsernames = [...new Set(usernames)];
    const messageDTO: CreateMessageDTO = {  
      ...formValue,
      recipient: uniqueUsernames,
    }
    this.messageService.sendMessage(messageDTO).subscribe()
  }

  private buildForm(): void {
    this.messageForm = this.fb.nonNullable.group({
      recipient: this.fb.nonNullable.control<Recipient[]>(
        [],
        Validators.required
      ),
      title: this.fb.nonNullable.control(
        '',
        Validators.required
      ),
      content: this.fb.nonNullable.control(
        '',
        Validators.required
      ),
    });
  }

}
